module.exports = __webpack_public_path__ + "img/website.a5267a30.svg";